/**
 *
 * WidgetProgress
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import ProgressBar from "components/ProgressBar"
import "./index.less"
import { get } from "lodash"

function WidgetProgress(data) {
  return (
    <div className="WidgetResponseRate boxShadow">
      <div className="subtitle_section" style={{ color: "#8D8D8D" }}>
        {data.title || ""}
      </div>
      <div className="WidgetResponseRate-body">
        <div className="WidgetResponseRate-body-data">
          <div
            className="WidgetResponseRate-body-data-percent color-black"
            style={{ fontWeight: "normal" }}>
            {get(data, "rate_visible", 0)}
          </div>
          <div
            className="WidgetResponseRate-body-data-medition"
            style={{ marginLeft: "auto" }}>
            <div>
              <b style={{ fontSize: 14 }} className="color-gray-low">
                Total:{" "}
              </b>
              <span
                style={{
                  display: "inline-flex",
                  marginTop: "5px",
                  fontSize: 14,
                }}>
                {get(data, "count", "0")}
              </span>
            </div>
          </div>
        </div>

        <div>
          <ProgressBar
            custom={{
              color: get(data, "color", "red"),
              value: get(data, "rate", 0),
            }}
          />
        </div>
      </div>
    </div>
  )
}

WidgetProgress.propTypes = {}

export default WidgetProgress
